import moment from 'moment'

export default function (container) {
  container.instance('moment', moment)
}
